import Layout from '../../layout/default';
import { useEffect, useState, useRef } from "react";
import { Link, Route, Routes} from 'react-router-dom'
import { Navigate } from "react-router-dom";
import { MediaGroup, Media, MediaText, Image, Icon, CustomDropdownToggle, CustomDropdownMenu, LinkList, LinkListItem, Rating } from "../../components";
import { Dropdown, Button, ButtonGroup } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { Breadcrumb } from 'react-bootstrap';
import { Modal, Row, Col, Form, Card} from 'react-bootstrap'
import { Block, DatePicker, TimePicker } from '../../components';
import RealtimeStatus from './RealtimeStatus';
import RefreshRealTimeNotifications from '../NotificationHub/RefreshRealTimeNotifications';
import JobsheetDetail from './JobsheetDetail';
import { useApiClient } from '../../ApiService/useApiClient';


const baseURL = "HMCareTask/getrealtimedata/?fromdate=" +new Date().toISOString();

const TodaysVisits = () => {

    const api = useApiClient();

    const[data, setdata] = useState(null);  
    const[filteredData, setfilteredData] = useState(null);  
    const[error, setError] = useState(null); 
    const dataFetchedRef = useRef(false);

    const [RefreshData, setRefresh] = useState(0);
    const [filterstatus, setfilterstatus] = useState("");    
    const [timerefresh, settimerefresh] = useState(false);    

    const [previewModal, setPreviewModal] = useState(false);
    const [previewModalselectedID, setPreviewModalselectedID] = useState(null);
    
    const getdata = async () => { api.get(baseURL)        
        .then((Response)=>{
            setdata(Response.data); 
            setfilteredData(Response.data);

            if(filterstatus!="")
                //setfilteredData(Response.data);
            //else
                setfilteredData(Response.data.filter(item=>item.status === filterstatus));  
            
        }).catch(error => {
            setError(error);     
            //console.log({error})
        });
    }

    const ApiGetData = async (URL,setdataFunc, setErrorFunc) => {
           
        try{
        const Response = await api.get(URL);

            setdata(Response.data); 
            setfilteredData(Response.data);

            if(filterstatus!="")               
                setfilteredData(Response.data.filter(item=>item.status === filterstatus));  
                
        } catch(error) {
            setError(error);      
        }
      };
    

      function closePreviewModal(){
        setPreviewModal(false);
      }
  

      const JobDetailClick= (taskID) => {

       // alert(taskID);

            setPreviewModalselectedID(taskID);
            setPreviewModal(true);

      };


    useEffect(()=>{                       

            //getdata();
            ApiGetData(baseURL)

          //}, [RefreshData,timerefresh]);
          }, [RefreshData]);


    // useEffect(() => {
    //         const interval = setInterval(() => {              
    //           settimerefresh(pretimerefresh=>!pretimerefresh)
    //         }, 30000);
    //         return () => clearInterval(interval);
    //       }, []);

    
        if (error) 
        {      
          if(error.message.indexOf("status code 401")){
            return <Navigate to="/auths/auth-login" />
          } else
          return "Error: ${error.message}";
        }
    
        if(!filteredData) return (
          <Layout title="Staff" content="container"><Spinner animation="border" variant="primary" /></Layout>
          );;
  
  
        const showOnly = (status) => {

            if (status == ''){
                setfilteredData(data);
            }
            else{
            setfilteredData(data.filter(item=>item.status === status));    
            setfilterstatus(status);
            }
        }



  return (
    <>
    
    <RefreshRealTimeNotifications setRefresh={setRefresh} />

    <Layout title="RealTime Visits" content="container"> 
    <Row className="g-gs">
        <Col className='h3'>Date : <span>{new Date().toLocaleString() + ''}</span></Col>       
        <Col>
             {/* <span>Filter</span>  */}
            <ButtonGroup className="ms-2">
                <Button variant="outline-light" size='sm' onClick={()=>showOnly('')}>All</Button>
                <Button variant="outline-danger" size='sm' onClick={()=>showOnly('No staff')}>No Staff</Button>
                <Button variant="outline-warning" size='sm' onClick={()=>showOnly('Delay')}>Delay</Button>
                <Button variant="outline-success" size='sm' onClick={()=>showOnly('In Progress')}>In Progress</Button>
                <Button variant="outline-info" size='sm' onClick={()=>showOnly('Completed')}>Completed</Button>
            </ButtonGroup>
        <Button variant="light" size='sm' className="ms-2" onClick={()=>{setRefresh(preRefrashData => preRefrashData+ 1);}}><Icon name="reload"></Icon>&nbsp;Refresh</Button>
        </Col>
    </Row><br></br>

    <Block>
        <Row className="g-gs">
            {
            filteredData.map((item) => (

                    <Col sm="5" xl="4" xxl="3" key={item.taskid}>
                        <Card className="text-center h-100" border="primary">
                            <Card.Body>                              
                                <div className="mt-1 mb-4"> 
                                                                                                 
                                    {/* <div className="small">{item.start_time} - {item.end_time}</div>                                    
                                    <div className="small">{item.start_time} - {item.end_time}</div>                                    
                                    <div className="small">{item.no_of_hours} Hour(s)</div>                                    
                                    <div className="small">{item.clientname}</div>                                    
                                    <div className="small">Carer : {item.assignedAgent}</div> 
                                    <br></br>                                   
                                    <div>
                                        <RealtimeStatus status= {item.status} />
                                    </div>                                                                        */}
                                    <div className="small">
                                    <span style={{fontWeight:'bold',}} onClick={()=>JobDetailClick(item.taskid)} ><u>{item.start_time}</u></span> - {item.no_of_hours.toFixed(1)} Hour(s) 
                                    <span style={{fontWeight:'bold',marginLeft:'10px', marginRight:'10px',}}>{item.clientname}</span>
                                    </div>                                                                                                                                                                                                        
                                    <div className="small">
                                        {/* <span style={{ padding :'20px',}}> */}
                                            Carer : {item.assignedAgent}
                                        {/* </span>    */}
                                     </div>                                                              
                                    <div className="small">
                                    <span><RealtimeStatus status= {item.status} /></span>
                                    </div>                                                                       
                                </div>         
                                <Button variant="outline-info" size='sm' onClick={()=>JobDetailClick(item.taskid)}>show detail</Button>                            
                            </Card.Body>
                        </Card>
                    </Col>
                ))
            }
        </Row>
     </Block>  

     <Modal show={previewModal} onHide={closePreviewModal} size="xl" backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title className="event-title" as="h4">JobID #{previewModalselectedID}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <JobsheetDetail taskid={previewModalselectedID} />              
              </div>
            </Modal.Body>
            <Modal.Footer>                
                <Button variant="light" onClick={closePreviewModal}>Cancel</Button>
                {/* {SiteConfig.CURRENT_USER_ROLE == "admin" && 
                <>
                <Button variant="danger" onClick={openDeleteModal}>Delete</Button>
                <Button variant="primary" onClick={openEditModal}>Edit Schedule</Button>
                </>
                } */}
            </Modal.Footer>
        </Modal>
       

</Layout>

</>                          


  )
}


export default TodaysVisits